import React from "react"
import * as Yup from "yup"
import { Text, Flex } from "@chakra-ui/react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import TextField from "components/ReactHookForm/TextField"
import * as api from "api/websites"
import { updateWebsite } from "context/actions"
import { useQueryClient } from "react-query"
import { PageHeaderFormValues } from "pages/EventShow/WebPage/types"

interface Props {
  eventId: string
  title: string
  onClose: () => void
  onHide: () => void
  onChange?: (values: PageHeaderFormValues) => void
}

const PageHeader = ({
  eventId, title, onClose, onHide, onChange,
}: Props) => {
  const queryClient = useQueryClient()

  const onSubmit = (values: { title: string }) => api.putWebsite(eventId, values)
    .then(({ data }) => {
      updateWebsite(queryClient, eventId, data)
      onHide()
    })

  return (
    <ModalForm
      title="Page Header"
      size="lg"
      onClose={onClose}
      initialValues={{ title: title || "" }}
      onSubmit={onSubmit}
      validationSchema={Yup.object().shape({ title: Yup.string().required() })}
      disableSubmitWhenNotDirty
      onChange={onChange}
    >
      {({ control }) => (
        <Flex flexDirection="column" gap={4} mb={24}>
          <Text fontSize="md">
            Enter the web page title to display within the hero image.
          </Text>
          <Flex w="100%">
            <TextField name="title" control={control} variant="outline" />
          </Flex>
        </Flex>
      )}
    </ModalForm>
  )
}

export default PageHeader
